<template>
    <li :class="{'has-child': hasChildren, 'child-open': open}">
        <a
            v-if="isAnchor"
            class="menu-item"
            :href="item.link"
            :target="target"
            @click="handleAnchorClick"
        >
            <img
                v-if="existIcon"
                class="menu-item-icon"
                :src="image(item.icon) || item.icon.link"
                :alt="itemText"
            >
            <span class="menu-item-text">{{ itemText }}</span>
        </a>

        <router-link
            v-else
            class="menu-item"
            :to="to()"
            :target="target"
        >
            <img
                v-if="existIcon"
                class="menu-item-icon"
                :src="image(item.icon) || item.icon.link"
                :alt="itemText"
            >
            <span class="menu-item-text">
                {{ itemText }}
            </span>
        </router-link>

        <ul
            v-if="hasChildren"
            class="menu-level menu-sub-level"
            :class="['menu-level-'+level, {open: open}]"
        >
            <template v-for="child in item.children">
                <menu-item
                    v-if="child.active"
                    :key="child.id"
                    :item="child"
                    :arrow="arrow"
                    :level="level + 1"
                    :translation="translation"
                />
            </template>
        </ul>

        <a
            v-if="arrow && hasChildren"
            href="#"
            class="menu-toggle"
            @click.prevent="open = !open"
        >
            <svg
                v-if="Number(arrow) === 2"
                width="8px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 256 256"
            >
                <path d="M225.813 48.907L128 146.72 30.187 48.907 0 79.093l128 128 128-128z" />
            </svg>
            <!-- eslint-disable-next-line max-len -->
            <svg
                v-else-if="Number(arrow) === 3"
                width="8px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 490.688 490.688"
            >
                <path
                    d="M472.328 120.53L245.213 347.665 18.098 120.53a10.67 10.67 0 0 0-15.083.262 10.67 10.67 0 0 0 0 14.82l234.667 234.667a10.67 10.67 0 0 0 15.083 0L487.432 135.61a10.67 10.67 0 0 0-14.821-15.345l-.262.262-.02.001z"
                    fill="#ffc107"
                />
                <!-- eslint-disable-next-line max-len -->
                <path d="M245.213 373.415c-2.83.005-5.548-1.115-7.552-3.115L2.994 135.633a10.67 10.67 0 0 1 .262-15.083 10.67 10.67 0 0 1 14.82 0l227.136 227.115L472.327 120.53a10.67 10.67 0 0 1 15.345 14.821L252.744 370.28a10.67 10.67 0 0 1-7.531 3.136z" />
            </svg>
            <svg
                v-else
                width="8px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 213.333 213.333"
            >
                <path d="M0 53.333L106.667 160 213.333 53.333z" />
            </svg>
        </a>
    </li>
</template>

<script>

    export default {

        name: 'MenuItem',

        props: {
            /**
             * Menu Item
             */
            item: Object,

            /**
             * Submenu Level
             */
            level: {
                type   : Number,
                default: 1,
            },

            /**
             * Arrow for the items with children
             */
            arrow: {
                type   : [Boolean, String, Number],
                default: false,
            },

            /**
             * Translate string
             */
            translation: Boolean,
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                open       : false,
                isAnchor   : typeof this.item.link === 'string' && (this.item.link.startsWith('http') || this.item.link.startsWith('#')),
                target     : this.item.external ? '_blank' : '_self',
                hasChildren: this.item.children && this.item.children.length,
            };
        },

        computed: {
            /**
             * Text of menu item
             *
             * @returns {string}
             */
            itemText() {
                if (this.translation) {
                    return this.$t(this.item.text);
                }
                return this.item.text;
            },

            /**
             * Check icon
             *
             * @returns {boolean}
             */
            existIcon() {
                return Array.isArray(this.item?.icon) ? this.item?.icon?.length : this.item?.icon;
            },
        },

        methods: {
            /**
             * Make router link
             * 
             * @returns {string}
             */
            to() {
                if (typeof this.item.link === 'string') {
                    return this.$route.params.locale
                        ? `/${this.$route.params.locale}/${this.item.link.replace(/^\/|\/$/g, '')}`
                        : this.item.link;
                }
                return this.item.link;
            },

            /**
             * Handle anchor click to prevent default for '#' links
             *
             * @param {*} e
             */
            handleAnchorClick(e) {
                if (this.item.link === '#') {
                    e.preventDefault();
                }
            },
        },

    };
</script>
